import React, { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { X } from 'lucide-react';

export function MediaPreview({
  imageUrl,
  onRemove,
}: {
  imageUrl: string;
  onRemove: () => void;
}) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box sx={{ mb: 1, mt: 1, display: 'inline-block' }}>
      <Box
        sx={{ position: 'relative', display: 'inline-block' }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Box
          component="img"
          src={imageUrl}
          alt="Preview"
          sx={{
            maxWidth: '170px',
            maxHeight: '130px',
            borderRadius: '8px',
            border: '1px solid',
            borderColor: 'divider',
            objectFit: 'contain',
            display: 'block',
          }}
        />
        {/* Small close button overlaying the image in top-right corner */}
        <IconButton
          size="small"
          onClick={onRemove}
          sx={{
            position: 'absolute',
            top: 4,
            right: 4,
            width: 20,
            height: 20,
            bgcolor: 'rgba(255, 255, 255, 0.95)',
            color: '#000',
            opacity: isHovered ? 1 : 0.8,
            transition: 'opacity 0.2s ease, background-color 0.2s ease',
            '&:hover': {
              bgcolor: '#fff',
              color: 'error.main',
              opacity: 1,
            },
          }}
        >
          <X size={12} />
        </IconButton>
      </Box>
    </Box>
  );
}

